<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- <div class="actual-ticket-edit-wrapper">
	<ng-template edit-type></ng-template>
</div> -->
<div
	class="actual-ticket-edit-wrapper"
	[ngClass]="{ 'ticket-edit-panel-visible': ticketEditService.ticketEditPanelIsDisplayed$ | async }"
	*ngIf="shouldDisplayEditWrapper$ | async"
	[ngSwitch]="ticketEditService.ticketTemplate$ | async"
>
	<task-edit
		*ngSwitchCase="TemplateType.task"
		positionTracker
		[callback]="positionTrackerCallback"
		[@scaleInOut]="flashStateSync"
		(@scaleInOut.done)="OnAnimationEvent($event)"
	>
	</task-edit>
	<milestone-edit
		*ngSwitchCase="TemplateType.milestone"
		positionTracker
		[callback]="positionTrackerCallback"
		[@scaleInOut]="flashStateSync"
		(@scaleInOut.done)="OnAnimationEvent($event)"
	>
	</milestone-edit>
	<constraint-edit
		*ngSwitchCase="TemplateType.constraint"
		positionTracker
		[callback]="positionTrackerCallback"
		[@scaleInOut]="flashStateSync"
		(@scaleInOut.done)="OnAnimationEvent($event)"
	>
	</constraint-edit>
	<multi-edit-task
		*ngSwitchCase="TemplateType.multiTask"
		positionTracker
		[@scaleInOut]="flashStateSync"
		(@scaleInOut.done)="OnAnimationEvent($event)"
	>
	</multi-edit-task>
	<multi-edit-milestone
		*ngSwitchCase="TemplateType.multiMilestone"
		positionTracker
		[@scaleInOut]="flashStateSync"
		(@scaleInOut.done)="OnAnimationEvent($event)"
	>
	</multi-edit-milestone>
	<multi-edit-constraint
		*ngSwitchCase="TemplateType.multiConstraint"
		positionTracker
		[@scaleInOut]="flashStateSync"
		(@scaleInOut.done)="OnAnimationEvent($event)"
	>
	</multi-edit-constraint>
	<div *ngSwitchDefault></div>
</div>

<!-- Begin ticket edit overlay components -->
<ticket-procore-link
	*ngIf="(ticketEditService.editOverlay$ | async) === 'procoreLink'"
	class="edit-overlay ticket-edit-content"
></ticket-procore-link>

<ticket-procore-status
	*ngIf="(ticketEditService.editOverlay$ | async) === 'procoreStatus'"
	class="edit-overlay ticket-edit-content"
></ticket-procore-status>

<ticket-pin-history
	*ngIf="(ticketEditService.editOverlay$ | async) === 'pinHistory'"
	[promiseStack]="promiseStack | async"
	[ticketType]="ticketType | async"
	[varianceList$]="planState.variances.list$"
	[isAdmin]="isAdmin$ | async"
	[hasAccess]="hasAcce$$ | async"
	[ticketDate]="editTicketFinish$ | async"
	[isActual]="editTicketIsActual$ | async"
	(saved)="writePromises($event)"
	(revert)="revertPromises($event)"
	(closed)="closeOverlay()"
	class="edit-overlay ticket-edit-content"
>
</ticket-pin-history>

<constraint-role-overlay
	*ngIf="(ticketEditService.editOverlay$ | async) === 'constraintRoleSelector'"
	[assignedProjectMember$]="assignedProjectMember | async"
	(closed)="closeOverlay()"
	class="edit-overlay ticket-edit-content"
></constraint-role-overlay>
